
export class UpButton
{
	static get defaults()
	{
		return {
			container: null,
			element: null,
			template: `
				<span class="sr-only">${BX.message('RS_ESHOP24_EXT_UPBUTTON_TEXT')}</span>
				<svg class="icon-svg" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/></svg>
			`,
			visibleOffset: 600,
			fixingBreakpoint: 768,
			position: {
				right: 40,
				bottom: 40,
			},
			cssClasses: {
				button: 'back-to-top',
				shown: 'is-shown',
				hidden: 'is-hidden',
				unfixed: 'is-unfixed'
			}
		};
	}

	constructor(options = {})
	{
		this.options = Object.assign(
			{}, 
			UpButton.defaults, 
			options
		);
		
		if (this.options.container)
		{
			this.container = this.options.container;
			delete this.options.container;
		}
		else
		{
			throw new Error('container is not defined');
		}

		if (this.options.button)
		{
			this.button = this.options.button;
			delete this.options.button;
		}
		else
		{
			this.button = this.createButton();
			this.container.appendChild(this.button);
		}

		this.setPosition(this.options.position);
		this.init();
	}

	setPosition({ top, right, bottom, left })
	{
		this.position = { top, right, bottom ,left };
		this.positionStyles = {
			top: this.position.top ? this.position.top + 'px' : 'auto',
			right: this.position.right ? this.position.right + 'px' : 'auto',
			bottom: this.position.bottom ? this.position.bottom + 'px' : 'auto',
			left: this.position.left ? this.position.left + 'px' : 'auto'
		}
	}

	createButton()
	{
		const button = document.createElement('button');
		button.classList.add(this.options.cssClasses.button);
		button.classList.add(this.options.cssClasses.hidden);

		button.innerHTML = this.options.template;

		return button;
	}

	init()
	{
		const onScroll = () =>  this.onScrollHandle();
		const checkAllowFixing = () => window.matchMedia(`screen and (min-width: ${this.options.fixingBreakpoint}px)`).matches;
		const enableFixing = () => {
			window.addEventListener('scroll', onScroll);
			if (this.checkVisible())
			{
				this.fixing();
			}
		};
		const disableFixing = () => {
			window.removeEventListener('scroll', onScroll);
			this.resetFixing();
		}

		let isAllowedFixing = checkAllowFixing();

		if (isAllowedFixing)
		{
			enableFixing();
		}

		window.addEventListener('resize', () => {
			const resizeIsAllowedFixing = checkAllowFixing();
			if (resizeIsAllowedFixing && !isAllowedFixing)
			{
				enableFixing();
			}
			else if (!resizeIsAllowedFixing && isAllowedFixing)
			{
				disableFixing();
			}

			isAllowedFixing = resizeIsAllowedFixing;
		});

		this.button.addEventListener('click', () => this.scrollTo());
	}

	fixing()
	{
		const { pageYOffset, innerHeight } = window;
		
		const containerRect = this.container.getBoundingClientRect();
		const containerYOffset =  pageYOffset + containerRect.top;

		const buttonRect = this.button.getBoundingClientRect();
		const buttonHeight = buttonRect.height;
		const buttonBottom = this.position.bottom || 0;

		if (containerYOffset >= pageYOffset + innerHeight - buttonHeight - buttonBottom)
		{
			this.applyFixing();
		}
		else
		{
			this.resetFixing();
		}
	}

	applyFixing()
	{
		Object.assign(this.button.style, {
			position: 'fixed',
			...this.positionStyles
		});
	}

	resetFixing()
	{
		this.button.style.removeProperty('position');
		this.button.style.removeProperty('top');
		this.button.style.removeProperty('right');
		this.button.style.removeProperty('bottom');
		this.button.style.removeProperty('left');
	}

	checkVisible()
	{
		if (window.pageYOffset > this.options.visibleOffset)
		{
			this.button.classList.remove(this.options.cssClasses.hidden);
			this.button.classList.add(this.options.cssClasses.shown);
			
			return true;
		}
		
		this.button.classList.remove(this.options.cssClasses.shown);
		this.button.classList.add(this.options.cssClasses.hidden);

		return false;
	}

	scrollTo()
	{
		window.scrollTo({
			top: 0,
			behavior: 'smooth'
		});
	}

	onScrollHandle()
	{
		if (this.checkVisible())
		{
			this.fixing();
		}
	}
}
